/*  =============================================
    Copyright © Hugo B.V. (acting under the brand name "Quriobot") - All Rights Reserved
    =============================================

    - Unauthorized copying of this file, via any medium is strictly prohibited
    - Proprietary and confidential
    - By using the Quriobot Website and/or Services, you signify you have read and
      accepted the Terms of Service on https://quriobot.com/terms of this Website and Services.
      If you do not agree to these Conditions, do not use Quriobot Website and/or Services.
    - Written by the good people of Hugo B.V. (acting under the brand name "Quriobot"), hello@quriobot.com, December 2016

    ============================================= */

var PanelTextAutoComplete = new Class({
  Extends: QuriobotElement,
  template: function () {
    var base =
      '<div class="input--wrapper input--autocomplete isLoading" data-qre-id="{{ id }}" data-qre-key="{{ key }}" id="{{ eid }}">' +
      '    <div class="input--error">' +
      '        <div class="error--avatar"></div>' +
      '        <div class="error--content" aria-hidden="true">' +
      '            {{ notFoundError }}' +
      '        </div>' +
      '    </div>' +
      '    <div class="panel--autocomplete no--options" id="options__{{ eid }}">' +
      '        <div class="panel--main">' +
      '            <ul role="listbox" id="page__{{ eid }}">' +
      '            </ul>' +
      '        </div>' +
      '    </div>' +
      '    <div class="input--inner">' +
      '        <div role="combobox" aria-expanded="false" aria-owns="page__{{ eid }}" aria-haspopup="listbox" aria-label="{{ title }}" class="input--content">' +
      '            <input autocomplete="off" aria-autocomplete="list" aria-controls="page__{{ eid }}" type="text" placeholder="{{ placeholder }}" class="data--wrapper" id="autoCompleteInput" />' +
      '        </div>' +
      '        <button type="button" type="submit" class="input--button hidden"></button>' +
      '    </div>' +
      '</div>'

    var option =
      '<li role="option" autocomplete-id="{{ id }}" class="option google--location">' +
      '      <span class="autocomplete--text">{{ description }}</span>' +
      '</li>'

    return {
      base: base,
      option: option,
    }
  },
  populate: function (notFoundError) {
    var base = this.template().base
    var data = Object.merge(this.data, { notFoundError: notFoundError || 'There are no suggestions' })
    Object.each(data, function (val, key) {
      base = base.replace(new RegExp('{{\\s*' + key + '\\s*}}', 'g'), val)
    })
    return base
  },
  populateOptions: function (options, append) {
    if (!options || !options.length) {
      var optionsHTML = false
    } else {
      var optionsHTML = ''
      options.each(
        function (obj) {
          var itemHTML = this.template().option
          Object.each(obj, function (val, key) {
            itemHTML = itemHTML.replace(new RegExp('{{\\s*' + key + '\\s*}}', 'g'), val)
          })
          optionsHTML += itemHTML + '\n'
        }.bind(this)
      )
    }

    this.addToDom(optionsHTML, append)
  },
  isUpdating: false,
  autoCompleteInput: null,
  isEmptyError: function (reset) {
    if (reset) {
      this.element.removeClass('hasError')
      this.element.getElements('.error--content')[0].set('aria-hidden', true)
      return
    }
    this.element.addClass('hasError')
    this.element.getElements('.error--content')[0].set('aria-hidden', false)
  },
  autocomplete: function () {
    var result
    var variants = this.data.options
    var newSearch = this.autoCompleteInput.value.toLowerCase()
    if (this.data.meta && this.data.meta.getOptionsScript) {
      if (this.autoCompleteInput.value) {
        this.getOptionsCallback(
          this.data.meta.getOptionsScript,
          this.autoCompleteInput.value,
          function (options) {
            if (options) {
              result = options.map(function (item) {
                return {
                  id: item.value,
                  description: item.label,
                }
              })
              this.isEmptyError(result.length > 0)
              result = result.slice(0, 10)
              this.populateOptions(result, true)
            }
          }.bind(this)
        )
      }
    } else {
      result = quriobot.search(variants, newSearch, this.data.meta && this.data.meta.searchThreshold).map(function (item) {
        return {
          id: item.id,
          description: item.text,
        }
      })

      result = result
        .filter(function (item) {
          return item !== null
        })
        .slice(0, 10)

      this.isEmptyError(result.length > 0)
      this.populateOptions(result, true)
    }
  },
  emptyOptions: function () {
    this.page_options.set('html', '')
  },
  addToDom: function (resultsData, update) {
    this.isUpdating = false
    var _a = this.questionApi
    this.quriobot.getError(
      this.data,
      'not_found',
      null,
      function (notFoundError) {
        if (!update) {
          var htmlContent = this.populate(notFoundError)
          this.inputContainer.set('html', htmlContent)
          this.page_options = $('page__' + this.data.eid)
          this.auto_options = $('options__' + this.data.eid)
        } else {
          if (resultsData) {
            if ($('autoCompleteInput').get('value').length >= 1) {
              //after redo these items can be lost somehow.
              if (this.page_options == undefined) {
                if ($('page__' + this.data.eid)) {
                  this.page_options = $('page__' + this.data.eid)
                } else {
                  return
                }
              }

              if (this.auto_options == undefined) {
                if ($('options__' + this.data.eid)) {
                  this.auto_options = $('options__' + this.data.eid)
                } else {
                  return
                }
              }
              this.show_autoCompleteOptions()
              this.page_options.set('html', resultsData)
              this.attach_options()
            }
          } else {
            this.hide_autoCompleteOptions()
          }
          return
        }

        this.in()
      }.bind(this)
    )
  },
  show_autoCompleteOptions: function () {
    if (this.auto_options) {
      this.auto_options.removeClass('no--options')
      $$('.input--content').set('aria-expanded', true)
    }
  },
  hide_autoCompleteOptions: function () {
    if (this.auto_options) {
      this.auto_options.addClass('no--options')
      $$('.input--content').set('aria-expanded', false)
    }
  },
  attach: function () {
    var _timer
    this.autoCompleteInput = $('autoCompleteInput')
    var autocomplete = FunctionUtilities.debounce(this.autocomplete.bind(this), 500)
    this.autoCompleteInput.addEvents({
      keyup: function (e) {
        if (this.autoCompleteInput.get('value').length < 1) {
          this.hide_autoCompleteOptions()
        } else {
          autocomplete()
        }
      }.bind(this),
      focus: function (e) {
        autocomplete()
      }.bind(this),
    })
    if (!BrowserData.isMobile) {
      if (!this.data.accessibilityMode) {
        this.autoCompleteInput.focus()
      }
    }
  },
  attach_options: function () {
    if (this.page_options) {
      var options = this.page_options.getElements('.option')
    }
    options.each(
      function (obj, i) {
        obj.removeEvents()
        obj.addEvents({
          click: function (e) {
            e.preventDefault()
            this.selectedOption = obj.clone()
            this.after()
          }.bind(this),
        })
      }.bind(this)
    )
  },
  after: function () {
    var textVal = this.selectedOption.getElements('.autocomplete--text')[0].get('text')
    var idVal = this.selectedOption.get('autocomplete-id')

    this.autoCompleteInput.set('value', textVal)
    this.hide_autoCompleteOptions()

    var answerData = {
      answer: {
        value: idVal,
        content: textVal,
        render: 'default',
      },
      id: this.element.get('data-qre-id'),
      key: this.element.get('data-qre-key'),
    }

    setTimeout(
      function () {
        this.out()
        this.answerCallback(this.data, answerData)
      }.bind(this),
      300
    )
  }
})
